export const HELPFUL_RATING_VALUE = 1;
export const UNHELPFUL_RATING_VALUE = 0;